<template>
  <iMineTemplate
    :pageTitle="pageTitle"
    :activedParentKey="activedParentKey"
    :activedKey="activedKey"
  >
    <template #rightContent>
      <div class="storeinfo">
        <div class="title" style="position:relative;">
          <span>新品收集</span>
        </div>
        <div class="content">
          <new-goods-collect-form/>
          <!-- 收集说明 -->
          <div class="collect-explain">
            <span class="explain-title">收集说明：</span>
            <div class="explain-item">
              {{collectDescribe}}
            </div>
          </div>
        </div>
      </div>
    </template>
  </iMineTemplate>
</template>

<script>
import { BaseMixin } from '@/mixins/BaseMixin'
import NewGoodsCollectForm from './components/NewGoodsCollect/NewGoodsCollectForm.vue'
export default {
  components: { NewGoodsCollectForm },
  mixins: [BaseMixin],
  name: 'NewGoodsCollect',
  data() {
    return {
      collectDescribe: '',
      pageTitle: ['我的账户', '新品收集'],
      activedParentKey: 1,
      activedKey: 50,
      urls: {
        CustomerContactDetail: '/api_customers/Customer/CustomerContactDetail',
      },
    }
  },
  mounted() {
    this.getCollectDescribe()
  },
  methods: {
      // 获取新品收集说明   
      async getCollectDescribe() {
      const res = await this.getAction('/api_goods/GoodsSku/newCollectDescribe',{Type: 1})
      if (res.IsSuccess) {
        this.collectDescribe = res.Data
      }
    }
  },
}
</script>
<style lang="less" scoped>
.storeinfo {
  margin: 0 20px 20px 0;
  width: 940px;
  padding: 20px;
  font-size: 16px;
  background: rgba(255, 255, 255, 1);
  border-radius: 2px;
  border: 1px solid rgba(232, 232, 232, 1);
  // padding: 20px;
  position: relative;
  box-sizing: border-box;

  .title {
    width: 898px;
    height: 42px;
    border-bottom: 1px solid #e8e8e8;
    line-height: 22px;

    span {
      float: left;
      font-size: 18px;
      color: rgba(34, 34, 34, 1);
    }
  }
  // 页面内容
  .content {
    display: flex;
    justify-content: space-between;
    padding-top: 22px;
    .collect-explain {
      color: #111a34;
      font-size: 12px;
      text-align: left;
      flex: 0 0 352px;
      .explain-title {
        display: block;
        margin-bottom: 12px;
      }
      .explain-item {
        // margin-bottom: 8px;
      }
    }
  }
}
</style>
